import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { DeclaracaoAnualService } from 'src/app/services/declaracao-anual.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

import { FormsModule } from '@angular/forms';
import { UtilService } from 'src/app/services/util.service';

@Component({
    selector: 'app-declaracao-anual',
    templateUrl: './declaracao-anual.component.html',
    styleUrls: ['./declaracao-anual.component.css'],
    imports: [FormsModule]
})
export class DeclaracaoAnualComponent implements OnInit {

  ano: number;  
  anos:any[] = [];

  paginaAtual : number = 1 ;
  qntPorPage : number = 10;
  exibeBotaoPDF: boolean = false;
  loadingGerarPDF: boolean = false;

  constructor(private utilService: UtilService, private declaracaoAnual: DeclaracaoAnualService, private toastr: ToastrService) { 

  }

  ngOnInit() {

    this.listarAnos();
  }

  listarAnos(){

    this.declaracaoAnual
        .listarAnos()
        .subscribe(
          (res: any)=> {
            this.anos = res;

            if(this.anos.length>0){
              this.ano = this.anos[0].ANO;
              this.exibeBotaoPDF = true;
            }
          },
          (error: HttpErrorResponse) => {
            console.error(error);
          }
        )
  }


  gerarPDF(){

    this.loadingGerarPDF = true;

    this.declaracaoAnual
        .gerarPDF(this.ano)
        .pipe(
          finalize(()=> { this.loadingGerarPDF = false })
        )
        .subscribe(
          (fileData) => {

            let nomeArquivo = `declaracao_anual_${this.ano}.pdf`;
            this.utilService.salvarArquivo(fileData, nomeArquivo);
          },
          (error: HttpErrorResponse) => {
            this.toastr.error(error.error.ex);
          }
        )

  }

}
